import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.join.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import organization from '@/components/organization';
import { sysInfoFn as _sysInfoFn } from '@/api/org/per';
import { payrollSubProjectCreate, savePayrollSubProject } from '@/api/payroll';
export default {
  props: {
    activeData: {
      type: Object
    }
  },
  components: {
    organization: organization
  },
  data: function data() {
    var _this = this;
    return {
      orgVisible: false,
      selectedLength: this.$t('179'),
      // 已选
      sysInfo: {},
      pickPeople: true,
      employessList: [],
      data: [],
      attData: [],
      leaveData: [],
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          // 考勤周期的选择范围是薪资周期开始时间的前一个月到薪资周期的结束时间
          var start_date = new Date(_this.form.start_date);
          start_date.setMonth(start_date.getMonth() - 1);
          var y = start_date.getFullYear();
          var m = start_date.getMonth() + 1;
          var d = start_date.getDate();
          var start = new Date(y + '-' + m + '-' + d).getTime();
          var last = new Date(_this.form.end_date).getTime();
          return time.getTime() > last || time.getTime() < start;
        }
      },
      form: this.activeData.info,
      ruleForm: this.activeData.ruleForm
    };
  },
  watch: {
    activeData: {
      handler: function handler(val) {
        this.form = val.info;
        this.attData = this.form.att_start_date ? [this.form.att_start_date, this.form.att_end_date] : [];
        this.data = this.form.start_date ? [this.form.start_date, this.form.end_date] : [];
        var leave = this.form.leave_start_date && this.form.leave_start_date !== '0000-00-00';
        this.leaveData = leave ? [this.form.leave_start_date, this.form.leave_end_date] : [];
        this.handleSelect();
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    disEid: function disEid() {
      // 计算失败、计算成功无法编辑
      return ['3', '4'].includes(this.form.calculate_state);
    }
  },
  created: function created() {
    var id = Number(this.$route.params.id);
    if (id) this.handleSelect();
    this.sysInfoFn();
  },
  methods: {
    sysInfoFn: function sysInfoFn() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _sysInfoFn();
            case 2:
              res = _context.sent;
              if (res && res.code === 1) _this2.sysInfo = res.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    openOrg: function openOrg() {
      // 打开选择人员弹窗
      this.orgVisible = true;
    },
    getSelectNode: function getSelectNode(data) {
      // 选择人员
      this.form.department_ids = data.dept_list;
      this.form.staff_ids = data.staff_list;
      this.handleSelect();
    },
    handleSelect: function handleSelect() {
      // 员工以选择文案
      var staff = Array.isArray(this.form.staff_ids) ? this.form.staff_ids.length : 0;
      var count = Array.isArray(this.form.department_ids) ? this.form.department_ids.length : 0;
      this.selectedLength = this.$t('179') + (count + staff);
    },
    handleFormal: function handleFormal() {
      // 员工属性改变
      if (!this.form.tax_deduction_status) this.form.tax_deduction_status = '3';
    },
    handleLeaveDateChange: function handleLeaveDateChange(v) {
      // 离职日期
      this.handlePicker(v, 'leave_start_date', 'leave_end_date');
    },
    handleDateChange: function handleDateChange(v) {
      // 薪资周期
      this.handlePicker(v, 'start_date', 'end_date');
      var start_date = new Date(this.form.start_date); // 薪资周期开始时间
      var end_date = new Date(this.form.end_date); // 薪资周期结束时间
      var start_date_time = start_date.getTime(); // 薪资周期开始时间戳
      var end_date_time = end_date.getTime(); // 薪资周期结束时间戳
      start_date.setMonth(start_date.getMonth() - 1);
      var start_y = start_date.getFullYear();
      var start_m = start_date.getMonth() + 1;
      var start_d = start_date.getDate();
      // 薪资周期前一个月时间戳
      var time = new Date(start_y + '-' + start_m + '-' + start_d).getTime();
      var att_start = new Date(this.form.att_start_date); // 考勤周期开始时间
      var att_end = new Date(this.form.att_end_date); // 考勤周期结束时间
      var att_start_time = att_start.getTime(); // 考勤周期开始时间戳
      var att_end_time = att_end.getTime(); // 考勤周期结束时间戳
      // 考勤周期结束日期，需要在薪资周期开始日期和结束日期中间
      if (att_end_time < start_date_time || att_end_time > end_date_time) {
        this.attData = [];
        this.handleAttDateChange();
      }
      // 考勤周期开始日期，需要在薪资周期开始日期和开始日期前一个月中间
      if (att_start_time < time || att_start_time > start_date_time) {
        this.attData = [];
        this.handleAttDateChange();
      }
    },
    handleAttDateChange: function handleAttDateChange(v) {
      // 考勤周期
      // console.log(v)
      // console.log(this.form.start_date, this.form.end_date)
      this.handlePicker(v, 'att_start_date', 'att_end_date');
    },
    handlePicker: function handlePicker(v, start, end) {
      // 处理日期
      if (v) {
        var _v = _slicedToArray(v, 2),
          startTime = _v[0],
          endTime = _v[1];
        this.form[start] = startTime;
        this.form[end] = endTime;
      } else {
        this.form[start] = '';
        this.form[end] = '';
      }
    },
    // 生成子项目
    saveData: function saveData() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var result, department_ids, staff_ids, query, _res, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              // 保存新建子项目信息
              result = false;
              if (!(_this3.form.staff_ids.length === 0 && _this3.form.department_ids.length === 0)) {
                _context2.next = 4;
                break;
              }
              // 请选择员工
              _this3.$message.error(_this3.$t('925'));
              return _context2.abrupt("return", false);
            case 4:
              _this3.form.sub_project_name = _this3.form.sub_project_name.trim();
              _this3.$refs.from.validate(function (valid) {
                result = valid;
              });
              if (!result) {
                _context2.next = 27;
                break;
              }
              // 处理数据，人员id
              department_ids = [];
              _this3.form.department_ids.forEach(function (item) {
                department_ids.push(item.department_id);
              });
              staff_ids = [];
              _this3.form.staff_ids.forEach(function (item) {
                staff_ids.push(item.staff_id);
              });
              query = _objectSpread(_objectSpread({}, _this3.form), {}, {
                department_ids: department_ids,
                staff_ids: staff_ids,
                staff_state: _this3.form.staff_state.join(),
                staff_formal: _this3.form.staff_formal.join()
              }); // activeData.sub_project_id 有值说明为编辑修改
              if (!_this3.activeData.sub_project_id) {
                _context2.next = 21;
                break;
              }
              query.sub_project_id = _this3.activeData.sub_project_id;
              query.calculate_state = _this3.form.calculate_state ? _this3.form.calculate_state : '0';
              // 保存编辑子项目信息
              _context2.next = 17;
              return savePayrollSubProject(query);
            case 17:
              _res = _context2.sent;
              if (!(_res && _res.code === 1)) {
                _context2.next = 21;
                break;
              }
              _this3.activeData.sub_project_id = _this3.form.sub_project_id;
              return _context2.abrupt("return", true);
            case 21:
              _context2.next = 23;
              return payrollSubProjectCreate(query);
            case 23:
              res = _context2.sent;
              if (!(res && res.code === 1)) {
                _context2.next = 27;
                break;
              }
              _this3.$s.set('sub_project_id', res.data.sub_project_id);
              return _context2.abrupt("return", true);
            case 27:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};